module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "container",
    staticClass: "vue-scrollbar-custom"
  }, [_c('div', {
    ref: "innerContainer",
    staticClass: "scrollbar-container",
    on: {
      "scroll": _vm.barScroll
    }
  }, [_c('div', {
    ref: "content",
    staticClass: "content-container"
  }, [_vm._t("default")], 2)]), (!_vm.isTopBar) ? _c('div', {
    ref: "barContainer",
    staticClass: "scroll_bar_container",
    style: ([_vm.barContainerStyle, {
      background: _vm.isHideBar ? 'rgba(0,0,0,0)' : _vm.barContainerStyle.background
    }]),
    on: {
      "mouseover": _vm.barHover,
      "mouseout": _vm.timeOutHideBar
    }
  }, [_c('div', {
    directives: [{
      name: "drag",
      rawName: "v-drag.dragY",
      value: ({
        ondrag: _vm.syncContent
      }),
      expression: "{ondrag:syncContent}",
      modifiers: {
        "dragY": true
      }
    }],
    ref: "bar",
    staticClass: "scroll_bar",
    style: ([_vm.barStyle, {
      opacity: _vm.isHideBar ? 0 : 1
    }])
  }, [_vm._t("barIn")], 2)]) : _c('div', {
    staticClass: "topBar_container"
  }, [_c('div', {
    ref: "topBar",
    staticClass: "topBar",
    style: (_vm.topBarStyle)
  }, [_vm._t("topBarIn")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-bc4c43fc"}!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue-scrollbar-custom/vue-scrollbar-custom.vue
// module id = 12
// module chunks = 0